export const energieberatung = [
    {
      "id": 400,
      "type": "radio-step",
      "description":"type of real estate",
      "title": "Förderung für mehr Energieeffizienz",
      "options": [
        {  id:"0", value:"Energieausweis", "next" : 998, "prev" : -1, "options": {"icon":"", "text":"Energieausweis", "size":"m"}},
        {  id:"1", value:"Individueller Sanierungsfahrplan (iSFP)", "next" : 998, "prev" : -1, "options": {"icon":"", "text":"Individueller Sanierungsfahrplan (iSFP)", "size":"m"}},
        {  id:"2", value:"Energieberatung für Nichtwohngebäude", "next" : 998, "prev" : -1, "options": {"icon":"", "text":"Energieberatung für Nichtwohngebäude", "size":"m"}},
        {  id:"3", value:"Baubegleitung", "next" : 998, "prev" : -1, "options": {"icon":"", "text":"Baubegleitung", "size":"m"}},
        {  id:"4", value:"Heizlastberechnung", "next" : 998, "prev" : -1, "options": {"icon":"", "text":"Heizlastberechnung", "size":"m"}},
        {  id:"5", value:"Weitere Energiethemen", "next" : 998, "prev" : -1, "options": {"icon":"", "text":"Weitere Energiethemen", "size":"m"}},
        
      ]
    },
  ] 